(function () {
    var MAX_TRIES = 120;  // ~6s
    var TRY_EVERY = 50;   // ms

    function ready(){
        return !!(window.jQuery && window.jQuery.fn && window.jQuery.fn.owlCarousel);
    }

    function init(){
        if (!ready()) return false;

        var $ = window.jQuery;
        var $el = $('#stints');
        if (!$el.length) return true;

        // Already initialised? Refresh instead.
        if ($el.hasClass('owl-loaded')) {
            try { $el.trigger('refresh.owl.carousel'); } catch(e){}
            return true;
        }

        $el.owlCarousel({
            loop: false,
            nav: false,
            autoplay: true,
            autoplayTimeout: 4000,
            autoplaySpeed: 400,
            responsive: {
                0:    { items: 1, margin: 0  },
                600:  { items: 3, margin: 16 },
                1000: { items: 3, margin: 16 }
            }
        });

        return true;
    }

    // Try immediately…
    if (init()) return;

    // …then after full page load…
    window.addEventListener('load', function once(){
        init(); window.removeEventListener('load', once);
    });

    // …plus short polling to bridge race conditions.
    var tries = 0, t = setInterval(function(){
        if (init() || (++tries >= MAX_TRIES)) clearInterval(t);
    }, TRY_EVERY);
})();